import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { SanitizeHtmlPipe } from 'src/_lib/pipes/sanitizeHtml';
 
@Component({
  selector: 'app-header-promotion',
  templateUrl: './header-promotion.component.html',
  styleUrls: ['./header-promotion.component.scss'],
  standalone: true,
  imports: [NgIf,SanitizeHtmlPipe],
  encapsulation: ViewEncapsulation.None,
  host: { 'ngSkipHydration': 'true' }
})
export class HeaderPromotionComponent {
  cdnImagePath: string = environment.cdnImagePath;
  @Input() custom_ticker: any;
}